/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { Heading, Text, theme } from "@nordcloud/gnui";
import { CloudProviderType, Maybe } from "~/generated/graphql";
import { AccountData } from "~/components/Forms/DiscoveryRulesForm";

type AccountSelectorItemListProps = {
  items: AccountData[];
  onSubmit: (id: string, provider?: Maybe<CloudProviderType>) => void;
};

export function AccountSelectorItemList({
  items,
  onSubmit,
}: AccountSelectorItemListProps) {
  return (
    <>
      {items.map(({ id, name, providerType }) => (
        <ItemContainer key={id} onClick={() => onSubmit(id, providerType)}>
          <Heading level={4}>{name}</Heading>
          <Text size="sm" tag="div" color={theme.color.text.text02}>
            {id}
          </Text>
        </ItemContainer>
      ))}
    </>
  );
}

const ItemContainer = styled.div`
  padding: ${theme.spacing.spacing02};
  border-bottom: 1px solid ${theme.color.border.border01};
  text-align: left;

  &:hover {
    cursor: pointer;
    background-color: ${theme.color.background.ui03};
  }
`;
